<template>
  <v-card class="mb-4 colorDominant">
    <div class="pa-3 grey--text">
      {{
        type === "popular"
          ? "Populares em apostas"
          : "Destaques em outras regiões"
      }}
    </div>
    <v-divider></v-divider>
    <div class="pt-3 pb-2 pl-3">
      <div style="overflow-x: auto" class="d-flex justify-space-between">
        <v-card
          v-for="(item, index) in items"
          :key="index"
          flat
          class="mr-4 text-center transparent"
          width="65"
          :to="item.href"
        >
          <v-img
            width="65"
            :src="item.src"
            :lazy-src="item.src"
            aspect-ratio="1"
            class="grey lighten-2"
            style="border-radius: 4px"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="caption pt-1 text-truncate">{{ item.label }}</div>
        </v-card>
      </div>
    </div>
  </v-card>
</template>
<script>
import peculiar from "./list-peculiar";
import popular from "./list-popular";

export default {
  name: "exceptional",
  props: ["type"],
  data: () => ({
    items: [],
  }),
  mounted() {
    this.items = this.type === "popular" ? popular : peculiar;
  },
};
</script>